import { Skeleton } from "@/components/ui/skeleton";

const KpiTileSkeleton = ({ index = 0 }) => {
  const delay = index * 60;
  return (
    <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-4">
      <Skeleton className="h-3 w-20 mb-3" delay={delay} />
      <Skeleton className="h-8 w-16 mb-2" delay={delay + 40} />
      <Skeleton className="h-2 w-full" delay={delay + 80} />
    </div>
  );
};

export default KpiTileSkeleton;
